<template>
    <v-layout>
      UNBEKANNTE GERÄTE
    </v-layout>
</template>

<script>
//import Vue from 'vue'
export default {
  name: 'unbekannteGeraete',
  components: {},
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
